var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _objectWithoutProperties = require("@babel/runtime/helpers/objectWithoutProperties");
var _slicedToArray = require("@babel/runtime/helpers/slicedToArray");
const _excluded = ["title"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const _require = require(/* configBehaviorIgnore: true */'spark-md5'),
  hash = _require.hash;
const optionValue = (option, value) => {
  if (option === undefined) {
    return undefined;
  }
  const _Object$keys = Object.keys(option),
    _Object$keys2 = _slicedToArray(_Object$keys, 1),
    key = _Object$keys2[0];
  if (key === undefined) {
    return undefined;
  }
  return option[key][value];
};
const optionTitle = option => optionValue(option, 'title');
const optionIdentifier = option => {
  if (option === undefined) {
    return undefined;
  }
  const _Object$keys3 = Object.keys(option),
    _Object$keys4 = _slicedToArray(_Object$keys3, 1),
    key = _Object$keys4[0];
  return key;
};
const optionsFromObjectArray = objectArray => objectArray.reduce((acc, obj, i) => {
  const title = obj.title,
    rest = _objectWithoutProperties(obj, _excluded);
  acc[hash(title)] = _objectSpread({
    title,
    _created: i + 1
  }, rest);
  return acc;
}, {});
const optionsFromStringArray = stringArray => optionsFromObjectArray(stringArray.map(title => ({
  title
})));
const optionFromString = title => optionsFromStringArray([title]);
module.exports = {
  optionValue,
  optionTitle,
  optionIdentifier,
  optionsFromObjectArray,
  optionsFromStringArray,
  optionFromString
};